import React, { Component } from "react";
import { Modal, Row, Col, Grid } from "react-bootstrap";
import "./modal.scss";
import "redcircle-brand-css/scss/redcircle.scss";
import closeIcon from "../../icons/modal-close-icon.svg";
import Spinner from "../lib/spinner";
import { If, classNames } from "react-extras";
import Divider from "../lib/divider";
import isNil from "lodash/isNil";

/*
  Passes in Content and Footer as components rather than functions
 */
class BaseModalV2 extends Component {
  render() {
    const {
      isLoading,
      isMini,
      Content,
      close,
      hideCloseButton,
      title,
      subTitle,
      showContent,
      Footer,
      modalProps,
      containerClass,
      noFooterShadow = false,
      hideFooter = false,
      hideTitleDivider = false,
      /* included for backwards compatability */
      hideMiniTitleDivider = true,
      isLarge = false,
      fillScreen,
      ref,
    } = this.props;
    const mainClasses = classNames(
      "seedcast-modal",
      "modal-dialog-centered",
      isMini && "seedcast-modal--mini",
      containerClass
    );

    return (
      <div className={"static-modal"}>
        <Modal
          dialogClassName={classNames(mainClasses, isLarge && "large", fillScreen && "fill-screen")}
          show={true}
          {...modalProps}
          ref={r => {
            ref && ref(r);
          }}>
          <If condition={!hideCloseButton}>
            <button onClick={close} className={"btn btn-link seedcast-modal__close-button"}>
              <img src={closeIcon} alt={"close-modal"} />
            </button>
          </If>
          <div className={classNames("seedcast-modal__content", isLarge && "large")}>
            <Grid fluid>
              <Row>
                <Col
                  xs={this.props.columns || 10}
                  xsOffset={isNil(this.props.offset) ? 1 : this.props.offset}
                  md={this.props.columns || 10}
                  mdOffset={isNil(this.props.offset) ? 1 : this.props.offset}>
                  <If condition={Boolean(title) || !hideTitleDivider}>
                    <div className={"seedcast-modal__header"}>
                      <If condition={Boolean(title)}>
                        <h2>{title}</h2>
                      </If>
                      <If condition={Boolean(subTitle)}>
                        <p>{subTitle}</p>
                      </If>
                      <If condition={!(isMini && hideMiniTitleDivider) && !hideTitleDivider}>
                        <Divider smallMargin className="seedcast-modal__title-divider" />
                      </If>
                    </div>
                  </If>
                </Col>
              </Row>
            </Grid>
            <Modal.Body>
              <Spinner isLoading={isLoading} />
              <If condition={showContent}>{Content}</If>
            </Modal.Body>
          </div>
          <If condition={!fillScreen}>
            <div className="flex-1" />
          </If>
          <If condition={!hideFooter}>
            <div
              className={classNames(
                "seedcast-modal__footer",
                Footer && "show-footer",
                noFooterShadow && "seedcast-modal__footer--no-shadow"
              )}>
              <div className={"seedcast-modal__footer-inner"}>{Footer}</div>
            </div>
          </If>
        </Modal>
      </div>
    );
  }
}

export default BaseModalV2;
